import { Dropdown, Button } from 'antd';
import type { MenuProps } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { setClientLanguage, type ClientLanguage } from '../i18n';

/** Compact language switcher for header / login. Default language is English. */
export function LanguageSwitcher({ size = 'middle' }: { size?: 'small' | 'middle' | 'large' }) {
  const { t, i18n } = useTranslation();
  const current: ClientLanguage = i18n.language === 'zh-CN' ? 'zh-CN' : 'en';

  const items: MenuProps['items'] = [
    {
      key: 'en',
      label: t('common.langEn'),
      disabled: current === 'en',
    },
    {
      key: 'zh-CN',
      label: t('common.langZh'),
      disabled: current === 'zh-CN',
    },
  ];

  const onClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'en' || key === 'zh-CN') {
      void setClientLanguage(key);
    }
  };

  return (
    <Dropdown menu={{ items, onClick }} placement="bottomRight">
      <Button
        type="text"
        size={size}
        icon={<GlobalOutlined />}
        aria-label={t('common.language')}
      >
        {current === 'zh-CN' ? t('common.langZh') : t('common.langEn')}
      </Button>
    </Dropdown>
  );
}

export default LanguageSwitcher;
